import * as React from 'react';
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
} from 'components/ui/table';
import { useInvoiceStore } from 'pages/tracking-v2/invoice-details-page/hooks';
import { Formatter } from 'utils';

const date = (date: string | null) => {
  return Formatter.date(date, { format: 'dd/MM/yyy HH:mm' });
};

const latLng = (lat: string, lng: string) => {
  return [lat, lng].filter(Boolean).join(', ');
};

export const GeolocationsList = () => {
  const { invoice } = useInvoiceStore();

  const geolocations = React.useMemo(() => {
    return invoice?.geolocation?.sort((a, b) => {
      return b.geolocationDate.localeCompare(a.geolocationDate)
    });
  }, [invoice?.geolocation]);

  return (
    <Table>
      <TableBody>
        {geolocations?.map((geo) => (
          <TableRow key={geo.id}>
            <TableCell className={'align-top w-[160px]'}>
              {date(geo.geolocationDate)}
            </TableCell>
            <TableCell className={'align-top w-[200px]'}>
              {latLng(geo.latitude, geo.longitude)}
            </TableCell>
            <TableCell className={'align-top'}>
              {geo.description}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};